import { IconCheckCircle } from '@nxsys/components/AppIconSvg';
import { message } from 'antd';
import type { NoticeType } from 'antd/es/message/interface';
// import { IconSuccess, IconWarning } from '@nxsys/components/AppIconSvg';

export function showMessage({
  type = 'info',
  content,
  duration = 3,

  ...rest
}: {
  type: NoticeType;
  content: string;
  duration?: number;
}) {
  // const icons: Partial<Record<NoticeType, React.ReactNode>> = {
  //   info: <IconWarning />,
  //   success: IconSuccess,
  //   error: <IconWarning />,
  //   warning: <IconWarning />,
  // };
  message.config({
    duration: 3,
    maxCount: 3,
  });
  message.open({
    type,
    content,
    duration,
    // icon: IconSuccess,
    icon:
      type === 'success' ? (
        <div className="mr-[8px]">
          <IconCheckCircle width={20} height={20} />
        </div>
      ) : undefined,
    ...rest,
  });
}
